import React from 'react'
import './Card.css'

const Card = ({ img1, img2 }) => {
  return (
    <>
      <div className='product'>
        <img class='img-bottom' src={img1} />
        <img className='img-top' src={img2} />
        <div className='text'></div>
        <div className='prod-info'>
          <button className='button price-btn buy-btn'>$600</button>
          <button className='button buy-btn instagram'>Buy on Instagram</button>
          <button className='button buy-btn whatsapp'>Buy on Whatsapp</button>
        </div>
      </div>
    </>
  )
}

export default Card
